export { default } from './FaqCardsBlock';
export * from './FaqCardsBlock';
